export default "__VITE_ASSET__Bs6wmjt4__"